import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const SERVICE_TYPES_REQUEST = 'SERVICE_TYPES_REQUEST';
export const SERVICE_TYPES_SUCCESS = 'SERVICE_TYPES_SUCCESS';
export const SERVICE_TYPES_FAILURE = 'SERVICE_TYPES_FAILURE';

export const SERVICE_DETAILS_REQUEST = 'SERVICE_DETAILS_REQUEST';
export const SERVICE_DETAILS_SUCCESS = 'SERVICE_DETAILS_SUCCESS';
export const SERVICE_DETAILS_FAILURE = 'SERVICE_DETAILS_FAILURE';

export const SERVICE_CREATE_REQUEST = 'SERVICE_CREATE_REQUEST';
export const SERVICE_CREATE_SUCCESS = 'SERVICE_CREATE_SUCCESS';
export const SERVICE_CREATE_FAILURE = 'SERVICE_CREATE_FAILURE';

export const SERVICE_UPDATE_REQUEST = 'SERVICE_UPDATE_REQUEST';
export const SERVICE_UPDATE_SUCCESS = 'SERVICE_UPDATE_SUCCESS';
export const SERVICE_UPDATE_FAILURE = 'SERVICE_UPDATE_FAILURE';

export function requestServiceTypes(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types?${query}`,
      method: 'GET',
      types: ['SERVICE_TYPES_REQUEST', 'SERVICE_TYPES_SUCCESS', 'SERVICE_TYPES_FAILURE']
    }
  };
}

export function requestServiceTypeDetails(serviceTypeId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types/${serviceTypeId}?${query}`,
      method: 'GET',
      types: [
        { type: 'SERVICE_DETAILS_REQUEST', meta: { serviceTypeId } },
        { type: 'SERVICE_DETAILS_SUCCESS', meta: { serviceTypeId } },
        { type: 'SERVICE_DETAILS_FAILURE', meta: { serviceTypeId } },
      ]
    }
  }
}

export function createServiceTypeDetails(service, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types?${query}`,
      method: 'POST',
      body: JSON.stringify(service),
      types: ["SERVICE_CREATE_REQUEST", "SERVICE_CREATE_SUCCESS", "SERVICE_CREATE_FAILURE"]
    }
  }
}

export function updateServiceTypeDetails(service, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types?${query}`,
      method: 'PUT',
      body: JSON.stringify(service),
      types: ["SERVICE_UPDATE_REQUEST", "SERVICE_UPDATE_SUCCESS", "SERVICE_UPDATE_FAILURE"]
    }
  }
}

export function deleteServiceType(serviceTypeId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types/${serviceTypeId}/deactivate?${query}`,
      method: 'PUT',
      types: ["SERVICE_DELETE_REQUEST", "SERVICE_DELETE_SUCCESS", "SERVICE_DELETE_FAILURE"]
    }
  }
}

export function uploadServiceTypeFiles(serviceTypeId, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));
  
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types/${serviceTypeId}/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['SERVICETYPE_UPLOAD_FILES_REQUEST', 'SERVICETYPE_UPLOAD_FILES_SUCCESS', 'SERVICETYPE_UPLOAD_FILES_FAILURE']
    },
  };
  
}

export function deleteServiceTypeFile(serviceTypeId, fileName, params) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types/${serviceTypeId}/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['SERVICETYPE_DELETE_FILE_REQUEST', 'SERVICETYPE_DELETE_FILE_SUCCESS', 'SERVICETYPE_DELETE_FILE_FAILURE']
    },
  };
}

export function downloadServiceTypeFile(serviceTypeId, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types/${serviceTypeId}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'REPORT_DOWNLOAD_FILE_REQUEST',
        {
          type: 'REPORT_DOWNLOAD_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'REPORT_DOWNLOAD_FILE_FAILURE']
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/services-manager/ServicesManagerActions.js